// extracted by mini-css-extract-plugin
export default {"card":"AddCard_card__o4h0a","add":"AddCard_add__OlG3q","iconAdd":"AddCard_iconAdd__w11-M"};